module.exports = __webpack_public_path__ + "img/icons.6a2bf68d.svg";